import { css, unsafeCSS } from 'lit';
import { fsFontWeightSemibold } from '@cof/fs-tokens';

export const style = css`
  .container {
    margin-bottom: 4rem;
    margin-right: 1rem;
    margin-left: 1rem;
  }

  refi-sign-in-card {
    display: block;
    cursor: pointer;
    margin: 0 auto 1em;
    max-width: 24em;
  }

  .easy-login-transition-header {
    padding: 1.5em;
  }

  .title-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
    text-align: center;
  }

  .spinner-container > * {
    display: flex;
    padding-top: 3em;
    padding-bottom: 19em;
    justify-content: center;
  }

  .easy-login-transition-logo {
    background-position: center top;
    text-align: center;
    padding-top: 1.5em;
    padding-right: 1.5em;
    padding-left: 1.5em;
  }

  .sign-in__banner {
    background: #013d5b;
    color: white;
    margin-bottom: 1em;
    padding: 1em 2em;
    text-align: center;
  }

  .sign-in__light {
    font-weight: 200;
  }
`;
